import { DateTime } from 'luxon'
import { faCalendar, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { Input } from '../../atoms/input'

interface IDatePickerInputProps {
  onChange: (dateString: string) => void
  selectsRange?: boolean
  dateFormat: string
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  startDate?: Date | null
  endDate?: Date | null
  onCalendarOpen?: () => void
  onCalendarClose?: () => void
  maxDate?: Date
  onClearClick?: () => void
  value?: string
  [key: string]: unknown
}

export const DatePickerInput = ({
  onChange,
  selectsRange,
  dateFormat,
  onClearClick,
  value,
  ...rest
}: IDatePickerInputProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!selectsRange) {
      onChange(e.target.value)
    }
  }

  const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    rest.onBlur?.(e)
    const parsedDateTime = DateTime.fromISO(e.target.value, { zone: 'utc' })

    if (parsedDateTime.isValid && !selectsRange) {
      onChange(parsedDateTime.toFormat(dateFormat))
    }
  }

  return (
    <Input
      className="dateInput"
      iconLeft={faCalendar}
      iconRight={value && onClearClick ? faTimes : undefined}
      onIconRightClick={onClearClick}
      iconRightClassName="pointer-events-auto z-101 hover:cursor-pointer"
      onChange={handleInputChange}
      onBlur={handleInputBlur}
      value={value}
      {...rest}
    />
  )
}
